import type { StakeholderTemplate, ProjectStakeholder } from '@bandos/shared'
import { MAX_TEAM_SIZE } from '../CharacterSelectionModal.types'
import { TeamSlotItem } from './TeamSlot'
import {
  TeamPanel as StyledTeamPanel,
  TeamHeader,
  SlotsContainer,
} from '../styles/CharacterSelectionModalStyles'

interface TeamPanelProps {
  projectStakeholders: ProjectStakeholder[]
  effectiveLimit: number
  operatingIds: Set<string>
  brokenPortraits: Set<string>
  markPortraitBroken: (id: string) => void
  getTemplateForSlot: (index: number) => StakeholderTemplate | null
  isGeneratingPortrait: (id: string) => boolean
  onCardSelect: (template: StakeholderTemplate) => void
  onSlotRemove: (index: number) => void
  onShowUpgrade: () => void
}

export function TeamPanel({
  projectStakeholders,
  effectiveLimit,
  operatingIds,
  brokenPortraits,
  markPortraitBroken,
  getTemplateForSlot,
  isGeneratingPortrait,
  onCardSelect,
  onSlotRemove,
  onShowUpgrade,
}: TeamPanelProps) {
  return (
    <StyledTeamPanel>
      <TeamHeader>
        Your Team ({projectStakeholders.length}/{MAX_TEAM_SIZE})
      </TeamHeader>
      <SlotsContainer>
        {Array.from({ length: MAX_TEAM_SIZE }).map((_, index) => {
          const template = getTemplateForSlot(index)
          const isOperating = template ? operatingIds.has(template.id) : false
          const isGenerating = template ? isGeneratingPortrait(template.id) : false
          const isLocked = index >= effectiveLimit

          return (
            <TeamSlotItem
              key={index}
              index={index}
              template={template}
              isLocked={isLocked}
              isOperating={isOperating}
              isGenerating={isGenerating}
              brokenPortraits={brokenPortraits}
              markPortraitBroken={markPortraitBroken}
              onSelect={onCardSelect}
              onRemove={onSlotRemove}
              onShowUpgrade={onShowUpgrade}
            />
          )
        })}
      </SlotsContainer>
    </StyledTeamPanel>
  )
}
